import {styled, Typography} from "@mui/material";
import {useTheme} from "@mui/system";
import TotalPriceIcon from "assets/icons/TotalPriceIcon";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import TableSelectPerson from "components/Input/TableSelectPerson";
import {PriceComponent} from "components/Shared/Dashboard/styled";
import {indexData} from "forms";
import {formatPrice} from "helpers/dataFormat";
import useDateState from "helpers/useDateState";
import {useSelector} from "react-redux";

const MainContainer = styled("div")(({theme}) => ({
    borderRadius: theme.shape.borderRadius,
    marginTop: "20px",
    height: "200px",
    display: "flex",
    flexDirection: "column",
}));
const LowerSectionContainer = styled("div")(({theme}) => ({
    backgroundColor: "white",
    display: "flex",
    padding: "10px",
    height: "108px",
    borderRadius: theme.shape.borderRadius,
    width: "100%",
    justifyContent: "space-between",
}));
const UpperSection = styled("div")(({theme}) => ({
    display: "flex",
    flexWrap: "wrap",
    padding: "10px",
    alignItems: "center",
    gap: 20,
    // borderRadius: `${theme.shape.borderRadius} ${theme.shape.borderRadius} 0 0`,
    paddingRight: "20px",
    width: "100%",
}));

const PriceItemContainer = styled("div")(({theme}) => ({
    width: "270px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
}));
const PriceItemRight = styled("div")(({theme}) => ({
    width: "120px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
}));

const PriceItem = ({title, price}: { title: string; price: number }) => {
    const theme = useTheme();

    return (
        <PriceItemContainer>
            <PriceItemRight>
                <TotalPriceIcon/>
                <Typography variant="body2" color={theme.palette.disabled.main}>
                    {title}
                </Typography>
            </PriceItemRight>
            <PriceComponent price={formatPrice(price)}/>
        </PriceItemContainer>
    );
};

const FactorProfitUpperComponent = ({
                                        refetch,
                                        type,
                                    }: {
    type: string;
    refetch: (paginationState: any, token: any, productId: any) => void;
}) => {
    // @ts-ignore
    const reportReducer = useSelector((state) => state).reportReducer;

    const totalProfit = reportReducer?.factorProfit?.totalProfit;
    const tabs = indexData(type);
    const {setDates, fromDate, toDate} = useDateState(tabs && tabs[0]);
    return (
        <MainContainer>
            <UpperSection>
                <div style={{width: 245}}>
                    <BasicDateInput
                        range
                        placeholder="کل سال مالی"
                        onChange={(x) => setDates(x)}
                        defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                    />
                </div>
                <TableSelectPerson refetch={refetch}/>
            </UpperSection>
            {/*<LowerSectionContainer>*/}
            {/*    <PriceItem title="سود کل کسب و کار" price={totalProfit}/>*/}
            {/*</LowerSectionContainer>*/}
        </MainContainer>
    );
};

export default FactorProfitUpperComponent;
